import React from 'react';
import { useLocation } from 'react-router-dom';
import RFIDeepLink from './RFIDeepLink';

const ProjectDeepLinks: React.FC = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const rfiQueryParam = queryParams.get('rfi');
  const rfiIdStr = rfiQueryParam ? rfiQueryParam.replace(' ', '+') : '';

  return rfiIdStr !== '' ? (
    <RFIDeepLink key={rfiIdStr} rfiId={rfiIdStr} />
  ) : null;
};

export default ProjectDeepLinks;
